var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"box-card elCard"},[_c('div',{staticClass:"clearfix headerTitle",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.mTitle))]),_c('div',{staticClass:"titleRight"},[_vm._t("titleRight")],2)]),_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }